import { render, staticRenderFns } from "./PromisesDelivery.vue?vue&type=template&id=76dd3881"
import script from "./PromisesDelivery.vue?vue&type=script&lang=js"
export * from "./PromisesDelivery.vue?vue&type=script&lang=js"
import style0 from "./PromisesDelivery.vue?vue&type=style&index=0&id=76dd3881&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports